var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleLayout',{attrs:{"custom":""}},[_c('el-container',[(_vm.menu.length > 0)?_c('el-aside',{attrs:{"width":_vm.asideWidth}},[_c('YSimpleMenu',{attrs:{"menu":_vm.menu}})],1):_vm._e(),_c('el-main',{staticStyle:{"padding":"0"}},[_c('YMainBody',[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }